
import { validateNumber } from "@om/validation";
import { 
    INTEREST_SET_VALUE, 
    LOAN_AMOUNT_SET_VALUE, 
    REPAYMENT_DURATION_SET_VALUE, 
    setInterestValid, 
    setLoanAmountValid, 
    setRepaymentDurationValid 
} from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { validationIsEqual } from "../status";

let prevValidationAction = null;
export const fauluLoanCalculatorFormValidation = (store, next, action) => {   
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case LOAN_AMOUNT_SET_VALUE:
                error = validateNumber(action.value, {
                    required: true,
                    subject: 'Loan Amount',
                    min: 1,
                    max: 2000000000,
                });
                return setLoanAmountValid(error);
            case INTEREST_SET_VALUE:
                error = validateNumber(action.value, {
                    required: true,
                    subject: 'Interest',
                    min: 1,
                    max: 100,
                });
                return setInterestValid(error);
            case REPAYMENT_DURATION_SET_VALUE:
                error = validateNumber(action.value, {
                    required: true,
                    subject: 'Repayment Period',
                    min: 1,
                    max: 1000,
                });
                return setRepaymentDurationValid(error);
            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
}